import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import LoadingApp from "../../../components/LoadingApp";
import './styles.css';
import VoltarButton from "../../../components/Accessibility/VoltarButton";
import ModalFeedBack from "../../../components/ModalFeedBack";
import { InvitationWarningCard } from "../../SaudeBemEstar/PalestrasEventos/InvitationWarningCard";
import { InvitationCard } from "./InvitationCard";
import { cancelarIntesseEvento, confirmarInteresseEvento, getConviteEvento } from "../../../services/SaudeBemEstar/GestaoDeCronicosService";
import { Convite } from "../../../interfaces/entities/SaudeBemEstar/PalestrasEventos/Convite";
import PageTitle from "../../../components/Accessibility/PageTitle";
import { atualizarIndLidoComunica } from "../../../services/ComunicadoService";
import { useNotification } from "../../../Store/contexts/NotificationContext";

const NotificationMedicinaPreventiva = () => {
    const navigate = useNavigate();
    const { idComunic, idEventoUsr } = useParams();
    const [invitation, setInvitation] = useState<Convite>({} as Convite);
    const [loading, setLoading] = useState<boolean>(false);
    const { updateUnreadNotificationsNumber } = useNotification();
    const [modalFeedback, setModalFeedback] = useState<null | {
        icon?: "none" | "warning" | "error" | "success",
        title?: string,
        textButton?: string,
        subTitle?: string,
        closeAction: () => void,
        showButtonModal: boolean,
        buttonAction?: () => void
    }>(null);
    const [searchParams] = useSearchParams();
    const lido = searchParams.get("lido");

    const handleGetConviteEvento = async () => {
        if (idComunic && idEventoUsr) {
            setLoading(true)
            getConviteEvento(idComunic, idEventoUsr).then((response) => {
                setInvitation(response)
            }).catch((error) => setModalFeedback({
                icon: 'warning',
                title: 'Atenção',
                subTitle: error.mensagem,
                textButton: 'Fechar',
                closeAction: () => navigate(-1),
                showButtonModal: true
            }))
                .finally(() => setLoading(false))
        }
        if (lido === 'N') {
            await atualizarIndLidoComunica(`${idComunic}`, 'S');
            await updateUnreadNotificationsNumber();
        }
    }

    const handleConfirmarInteresse = () => {
        setLoading(true);
        const data = {
            idComunic: idComunic ?? '',
            idCtrlEventoUsr: idEventoUsr ?? '',
        };
        confirmarInteresseEvento(data).then(
            () => {
                navigate('/saudeBemEstar/palestrasEventos/confirmados')
            })
            .catch(() =>
                setModalFeedback({
                    icon: 'error',
                    title: 'Erro',
                    subTitle: 'Ocorreu um erro, tente novamente em alguns instantes.',
                    textButton: 'Fechar',
                    closeAction: () => setModalFeedback(null),
                    showButtonModal: true
                })
            )
            .finally(() => {
                setLoading(false);
            });

    };

    const handleCancelarInteresse = () => {
        setLoading(true);
        const data = {
            idComunic: idComunic ?? '',
            idCtrlEventoUsr: idEventoUsr ?? '',
        };
        cancelarIntesseEvento(data).then(
            () => {
                navigate(-1)
            })
            .catch(() =>
                setModalFeedback({
                    icon: 'error',
                    title: 'Erro',
                    subTitle: 'Ocorreu um erro, tente novamente em alguns instantes.',
                    textButton: 'Fechar',
                    closeAction: () => setModalFeedback(null),
                    showButtonModal: true
                })
            )
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        handleGetConviteEvento()
    }, [])

    return (
        <div className='notification-med-prev'>
            {!loading && !!invitation?.especialidade &&
                <>
                    <PageTitle text="Medicina Preventiva" />
                    <InvitationWarningCard title="ATENÇÃO:"
                        message="Este evento poderá sofrer alterações. Você será notificado se for o caso" />

                    <InvitationCard
                        invitation={invitation}
                        onConfirm={handleConfirmarInteresse}
                        onCancel={handleCancelarInteresse}
                    />
                    <VoltarButton onClick={() => navigate(-1)} />
                </>
            }
            <LoadingApp showLoading={loading} />
            {modalFeedback && (
                <ModalFeedBack
                    showModal={!!modalFeedback}
                    icon={modalFeedback?.icon as 'success' | 'error'}
                    title={modalFeedback?.title ?? ''}
                    subTitle={modalFeedback.subTitle ?? ''}
                    textButton={modalFeedback.textButton ?? ''}
                    showButtonModal={modalFeedback.showButtonModal}
                    handleButtonModal={modalFeedback.buttonAction || modalFeedback.closeAction}
                    handleShowModal={modalFeedback.closeAction}
                    classNameModal="modal-custom"
                />
            )}
        </div>
    );
};

export default NotificationMedicinaPreventiva;
